import { useEffect, useState } from "react";
import { waitForDOMElReady } from "../_helpers/_dom";

/**
 * Simple way to click on a bots on button (use `trigger()`)
 * @param {string} selector
 * @returns {{el: null|Element, trigger: function}}
 */
const useBotOnButton = (selector) => {
	const [button, setButton] = useState(null);

	useEffect(() => {
		if (typeof window === "undefined") {
			return;
		}
		const getButton = async () => {
			try {
				const selectorAppendage = selector.substr(0, 1) === "." ? selector : `#${selector.replace("#", "")}`;
				const btn = await waitForDOMElReady(".bob-button" + selectorAppendage);
				setButton(btn);
			} catch {
				return null;
			}
		};

		getButton();
	}, [selector]);

	/**
	 * @type function
	 * @returns void
	 */
	const trigger = () => {
		if (button) {
			button.click();
		}
	};

	return {
		el: button,
		trigger,
	};
};

export default useBotOnButton;
